module.exports = __webpack_public_path__ + "static/media/circle-left-silver.433333ed.svg";